export const RESIZE_DIRECTION_TYPES = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  BOTH: 'both',
}
